export const EDIT_CUSTOMERS_ATTACHMENT_NAME_REQUEST = 'EDIT_CUSTOMERS_ATTACHMENT_NAME_REQUEST';
export const EDIT_CUSTOMERS_ATTACHMENT_NAME_SUCCESS = 'EDIT_CUSTOMERS_ATTACHMENT_NAME_SUCCESS';
export const EDIT_CUSTOMERS_ATTACHMENT_NAME_FAILURE = 'EDIT_CUSTOMERS_ATTACHMENT_NAME_FAILURE';
